/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineCustomTags extends models.TagBaselineAvailableTag {
    getFixupPrototypeFunction() { return TagBaselineCustomTags.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineCustomTags>): TagBaselineCustomTags {
        let obj = Object.assign(new TagBaselineCustomTags(), model);
        TagBaselineCustomTags.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineCustomTags>): TagBaselineCustomTags {
        if (!model) return null;
        return TagBaselineCustomTags.newInstance(<TagBaselineCustomTags> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineCustomTags) {
        if (!obj) return;

        models.TagBaselineCustomTags.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineCustomTags): boolean {
        if (models.TagBaselineAvailableTag.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineCustomTags.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regular expression pattern to validate tag values, ensuring they follow a predefined format.
     */
    regex_pattern: string;

}
